export interface ProcessedReportDetails {
  autoFitColumnWidths?: string;
  format?: string;
  pdfLogoSelection?: string;
  includeItems: string[];
  excludeItems: string[];
  otherCriteria: { label: string; value: string }[];
}

function isDatePattern(expression: string): boolean {
  return /^\d{1,2}-\d{1,2}-\d{4}$/.test(expression);
}

//Requirements dont include pdf logo selection or the other criteria fields but
// but keeping this here in case its needed later
export function processReportDetails(
  details: { label: string; expression: string }[],
): ProcessedReportDetails {
  if (!details || details.length === 0) {
    return {
      autoFitColumnWidths: undefined,
      format: undefined,
      pdfLogoSelection: undefined,
      includeItems: [],
      excludeItems: [],
      otherCriteria: [],
    };
  }

  // Fields that go to second column (file info)
  const fileInfoLabels = [
    'Auto-Fit Column Widths',
    'Output Type',
    //'PDF Logo Selection', Requirements does not include this field
  ];

  const autoFitColumnWidths = details.find(
    (item) => item.label === 'Auto-Fit Column Widths',
  )?.expression;

  const format = details.find(
    (item) => item.label === 'Output Type',
  )?.expression;

  const pdfLogoSelection = details.find(
    (item) => item.label === 'PDF Logo Selection',
  )?.expression;

  const includeItems = details
    .filter(
      (item) =>
        item.expression === 'Include' && !isDatePattern(item.expression),
    )
    .map((item) => item.label);

  const excludeItems = details
    .filter(
      (item) =>
        item.expression === 'Exclude' && !isDatePattern(item.expression),
    )
    .map((item) => item.label);

  const otherCriteria = details
    .filter((item) => {
      if (isDatePattern(item.expression)) {
        return true;
      }

      if (item.expression === 'Include' || item.expression === 'Exclude') {
        return false;
      }

      if (fileInfoLabels.includes(item.label)) {
        return false;
      }
      return true;
    })
    .map((item) => ({
      label: item.label,
      value: item.expression,
    }));

  return {
    autoFitColumnWidths,
    format,
    pdfLogoSelection,
    includeItems,
    excludeItems,
    otherCriteria,
  };
}
